import type { WebhookStatus } from "@app/analytics/types/webhookTypes";

export const WEBHOOK_STATUS_LABEL: {
  [key in WebhookStatus]: string;
} = {
  active: "Active",
  errored: "Needs Attention",
  inactive: "Paused",
  pending: "Pending",
  stopped: "Stopped",
};

export const TRIGGER_LABEL = {
  meeting_end: "meeting end",
};

export const WEBHOOK_STATUS_SORT_IMPORTANCE = new Map([
  ["stopped", 1],
  ["errored", 2],
  ["active", 3],
  ["pending", 4],
  ["inactive", 5],
]);
